import type { FaireProductEntity } from "../../entity_types/product";

export const p_fzephhahw7: FaireProductEntity = {
  token: "p_fzephhahw7",
  type: "product",
  name: "Off Leash Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6895c7ea56c76e604e9495a7b2ee1c6df7b8341624abefa445d762ea049d247a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/264e05d14f0ca69ddea7d04dc9cca924e1e9d152900c30956d5e3a1f97ba450c.jpeg",
    "https://cdn.faire.com/fastly/34841fa5f25d09cdf13ec624c75651efa31ebee43d703dc5e34eef6811321ac8.png",
  ],
  priceDollars: 9,
  description:
    "Who doesn't love a fresh, crisp and clean new notepad?! It's such a hopeful item. Just think of all you will go through together! \n\nAt E. Frances, we want each page to bring joy to your list-making, doodling and note-taking.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:14.763Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
